import { Condition } from 'client/voladeum/conditions/types';
import { indicator_default } from 'ducks/indicator/defaults';

export const condition_default: Condition = {
  condition_id: 0,
  measure: { ...indicator_default },
  threshold: { ...indicator_default },
  operator_id: null,
  operator_name: null,
  trigger_id: 0,
  update_date: new Date(),
  created_date: new Date(),
  uuid: '',
};
